import { render, staticRenderFns } from "./vselect.vue?vue&type=template&id=236eb56d"
import script from "./vselect.vue?vue&type=script&lang=js"
export * from "./vselect.vue?vue&type=script&lang=js"
import style0 from "./vselect.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports